<button  type="button" class="medlemsinfo" (click)="byttDetaljvisning()">
  <avatar [medlem]="visningsmedlem()" [stil]="viserDetaljer() ? 'stor' : ''"/>
  <i class="icon tilgangikon" [class.ion-checkmark-round]="visningsmedlem().harTilgang"
     [class.tilgangikon-aapen]="visningsmedlem().harTilgang"
     [class.ion-close-round]="!visningsmedlem().harTilgang"
     [class.tilgangikon-stengt]="!visningsmedlem().harTilgang" aria-hidden="true"></i>
  <span class="medlemsinfo-tekst">
    @if (gruppe(); as medlemsgruppe) {
      <span>{{ medlemsgruppe.organisasjonsnavn }} - {{ medlemsgruppe.tittel }}</span>
    }
    <span>{{ visningsmedlem().navn }} - {{ visningsmedlem().aktiveMedlemsroller[0]?.tittel ?? '' }}</span>
  </span>
</button>

@if (viserDetaljer() && gruppe(); as medlemsgruppe) {
  <div class="medlemdetaljer" data-testid="medlem-detaljer">
    <tittel-verdi-samling stil="vertikal">
      <tittel-verdi stil="horisontal" tittel="ID" verdi="{{ visningsmedlem().id }}"/>
      <tittel-verdi stil="horisontal" tittel="Navn" verdi="{{ visningsmedlem().navn }}"/>
      <tittel-verdi stil="horisontal" tittel="BrukerID" verdi="{{ visningsmedlem().brukerId }}"/>
      <tittel-verdi stil="horisontal" tittel="Epost" verdi="{{ visningsmedlem().epost }}"/>
      <tittel-verdi stil="horisontal" tittel="mobilnummer" verdi="{{ visningsmedlem().mobilnummer }}"/>
      <tittel-verdi stil="horisontal" tittel="organisasjonsnavn" verdi="{{ medlemsgruppe.organisasjonsnavn }}"/>
      <tittel-verdi stil="horisontal" tittel="Gruppetittel" verdi="{{ medlemsgruppe.tittel }}"/>
      <tittel-verdi stil="horisontal" tittel="GruppeId" verdi="{{ medlemsgruppe.id }}"/>
      <tittel-verdi stil="horisontal" tittel="Tilgangsroller" verdi="{{ tilgangsrollerTekst() }}"/>
      <tittel-verdi stil="horisontal" tittel="tidssone" verdi="{{ visningsmedlem().tidssone }}"/>
      <tittel-verdi stil="horisontal" tittel="Språk" verdi="{{ visningsmedlem().spraak }}"/>
      <tittel-verdi stil="horisontal" tittel="har tilgang" ><verdi>
        <i class="icon tilgangikon-liten" [class.ion-checkmark-round]="visningsmedlem().harTilgang"
        [class.tilgangikon-aapen]="visningsmedlem().harTilgang"
        [class.ion-close-round]="!visningsmedlem().harTilgang"
        [class.tilgangikon-stengt]="!visningsmedlem().harTilgang" aria-hidden="true"></i>
      </verdi></tittel-verdi>
      <tittel-verdi stil="horisontal" tittel="invitasjonsstatus" verdi="{{ invitasjonsstatusTekst(visningsmedlem().invitasjonsstatus) }}"/>
      <tittel-verdi stil="horisontal" tittel="medlemstatus" verdi="{{ medlemsstatusTekst(visningsmedlem().medlemstatus) }}"/>
    </tittel-verdi-samling>
    <section class="roller">
      <div>
        <h4>{{ 'Roller' | translate }}</h4>
        <ul>
          @for (rolle of visningsmedlem().aktiveMedlemsroller; track rolle.id) {
            <li>{{ rolle.tittel }} {{ rolle.periode | datoperiodeutentid }}</li>
          }
        </ul>
      </div>
      <div>
        <h4>{{ 'Inaktive roller' | translate }}</h4>
        <ul>
          @for (rolle of visningsmedlem().inaktiveMedlemsroller; track rolle.id) {
            <li>{{ rolle.tittel }} {{ rolle.periode | datoperiodeutentid }}</li>
          }
        </ul>
      </div>
    </section>

    @if (visningsmedlem().harTilgang) {
      <button mat-raised-button color="warn" type="button" class="e2e-stengtilgang" (click)="stengTilgang()">
        {{ 'Steng tilgang' | translate }}
      </button>
    }
    @if (kanGiTilgang()) {
      <button mat-raised-button color="primary" type="button" (click)="gjenaapneTilgang()">
        {{ 'Åpne tilgang' | translate }}
      </button>
    }
  </div>
}
